import { HealthRecordsFamilyHistory } from "../ui-components";
import { useNavigate } from "react-router-dom";

const HealthRecordsFamilyHistoryPage = () => {
  const navigate = useNavigate();
  return (
    <HealthRecordsFamilyHistory
      overrides={{
        fhCommentCardPerson1: {
          overrides: {
            ccImage: { src: "/images/user-mother.jpg" },
            ccName: { children: "Barbara Janness" },
            ccIllnessList: {
              children: ["Illness List:\n Arthritis\n Diabetes\n"],
            },
          },
        },
        fhCommentCardPerson2: {
          overrides: {
            ccImage: { src: "/images/user-brother.jpg" },
            ccName: { children: "John Janness" },
            ccRelationship: { children: "Relationship: Brother" },
            ccIllnessList: {
              children: ["Illness List:\n Asthma\n High Blood Pressure\n"],
            },
            ccAge: { children: "Age: 32" },
          },
        },
        piAdd: {
          onClick: () => {
            navigate("/user/hr/family-history/add");
          },
        },
      }}
    />
  );
};

export default HealthRecordsFamilyHistoryPage;
